import { render, staticRenderFns } from "./IcSeparate.vue?vue&type=template&id=384794e6&scoped=true"
import script from "./IcSeparate.vue?vue&type=script&lang=js"
export * from "./IcSeparate.vue?vue&type=script&lang=js"
import style0 from "./IcSeparate.vue?vue&type=style&index=0&id=384794e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384794e6",
  null
  
)

export default component.exports